import * as React from 'react';

import { TextField } from '@mui/material';
import { StandardTextFieldProps } from '@mui/material/TextField';
import NumberFormat, { NumberFormatValues } from 'react-number-format';

/////////////////////////////////////////////////////////////////////////////////////

interface INumericProps {
    maxLength?: number;
    inputWidth?: number | string;
    allowNegative?: boolean;
    allowEmptyFormatting?: boolean;
    isAllowed?: (values: NumberFormatValues) => boolean;
};


interface INumberFormaCustomProps {
    id: any,
    name: any,
    inputRef: any,
    onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
};


const NumberFormatCustom: React.FC<INumberFormaCustomProps & INumericProps> = (props) => {
    const { id, name, inputRef, onChange, ...rest } = props;

    return (
        <NumberFormat
            {...rest}
            id={id}
            name={name}
            getInputRef={inputRef}
            onValueChange={
                (values) => {

                    if (props["value"] != values.floatValue) {
                        const event = {
                            target: {
                                id: id,
                                name: name,
                                value: values.value,
                                valueAsNumber: values.floatValue,
                            }
                        } as React.ChangeEvent<HTMLInputElement>;

                        onChange(event);
                    }
                }
            }
        />
    );
}

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    inputVariant?: "number" | "currency",
}

type Props = IProps & INumericProps & StandardTextFieldProps;

const TextFieldNumeric: React.FC<Props> = (props) => {
    const { placeholder, inputVariant, maxLength, InputProps, inputProps, allowEmptyFormatting, allowNegative, isAllowed, inputWidth, value, ...rest } = props;

    const style = {};
    if (inputWidth) style["width"] = inputWidth;

    return (
        <TextField
            {...rest}
            value={value}
            placeholder={placeholder}
            InputLabelProps={
                {
                    shrink: (placeholder != null && placeholder.length > 0) || value != null
                }
            }
            InputProps={

                {
                    ...InputProps,
                    style: style,
                    inputComponent: NumberFormatCustom,
                    inputProps: {
                        maxLength: maxLength,
                        allowEmptyFormatting: allowEmptyFormatting,
                        allowNegative: allowNegative,
                        isAllowed: isAllowed,
                        decimalScale: inputVariant == "number" ? 0 : 2,
                        decimalSeparator: ",",
                        thousandSeparator: ".",
                    }
                }
            }
        />
    );
}

TextFieldNumeric.defaultProps = {
    inputVariant: "number"
}

export default TextFieldNumeric;